import { memo, useEffect } from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { InputLabel, TextField } from '@mui/material';
import { BaseRow } from '~/components/common';
import { NumericFormat } from 'react-number-format';
import { IResponseGetEstimate } from '~/utils/interface/estimate';
import { IInvoice } from '~/utils/interface/invoice';
import { cast } from '~/utils/helper';
import { IResponseGetEstimateTemplate } from '~/utils/interface/estimate-template';

type PaymentCalculationProps = {
  form: any;
  subtotal: number;
  totalTax?: number;
  editData?: IResponseGetEstimate | IInvoice | IResponseGetEstimateTemplate;
  onChangeTax?: (value: number) => void;
};
function PaymentCalculation(props: PaymentCalculationProps) {
  const { form, editData, onChangeTax } = props;
  const { t } = useTranslation('admin/job');

  useEffect(() => {
    if (editData) {
      form.setFieldValue('subtotal', editData?.subtotal);
      form.setFieldValue('total', editData?.total);
      form.setFieldValue('tax', editData?.tax);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData]);
  return (
    <Box>
      <Box className='bg-[#F3F9FF] w-full my-4 p-5 font-[600] text-[14px] border-y-2 border-solid border-y-[#e5eaef]'>
        {t('estimate.paymentCalculation.title')}
      </Box>
      <Box className='mt-3 p-5 w-2/3'>
        <BaseRow className='gap-[30px]'>
          <Box className='w-full'>
            <InputLabel> {t('estimate.paymentCalculation.total')}</InputLabel>
            <NumericFormat
              customInput={TextField}
              value={cast(form.values.total)}
              onValueChange={(val) => form.setFieldValue(`total`, val.floatValue)}
              thousandSeparator={true}
              prefix={'$'}
              decimalScale={2}
            />
          </Box>

          <Box className='w-full'>
            <InputLabel>{t('estimate.paymentCalculation.subtotal')}</InputLabel>
            <NumericFormat
              customInput={TextField}
              value={cast(form.values.subtotal)}
              onValueChange={(val) => form.setFieldValue(`subtotal`, val.floatValue)}
              thousandSeparator={true}
              prefix={'$'}
              decimalScale={2}
            />
          </Box>

          <Box className='w-full'>
            <InputLabel> {t('estimate.paymentCalculation.tax')} </InputLabel>
            <NumericFormat
              customInput={TextField}
              value={cast(form.values.tax)}
              onValueChange={(val, sourceInfo) => {
                // Trigger tax change whenever the input is trigger by user behavior
                if (sourceInfo?.event) {
                  onChangeTax && onChangeTax(val.floatValue || 0);
                }

                form.setFieldValue(`tax`, val.floatValue);
              }}
              thousandSeparator={true}
            />
          </Box>
        </BaseRow>
      </Box>
    </Box>
  );
}

export default memo(PaymentCalculation);
